import { NotifyDialog } from '~/components/notify'
import React from 'react'
import { observer } from 'mobx-react-lite'
import { additionalInfoApplyDialogStore } from '~/components/additional-info-apply-dialog/additional-info-apply-dialog.store'
import { careJobDetailStore } from '~/features/care-jobs/detail/care-job-detail.store'
import { quickApplyStore } from '~/features/quick-apply/quick-apply.store'

export const MatchProfessionDialog = observer(() => {
	const { showDialogMatchProfession, setShowDialogMatchProfession } = additionalInfoApplyDialogStore
	const { setShowApplyUpdateDialog } = careJobDetailStore
	const { currentJob } = quickApplyStore
	return (
		<NotifyDialog
			onClose={() => {
				setShowDialogMatchProfession(false)
			}}
			showButtonClose={true}
			okText="Update my professions"
			open={showDialogMatchProfession}
			onOk={async () => {
				await setShowDialogMatchProfession(false)
				await setShowApplyUpdateDialog(true)
			}}
			children={
				currentJob?.atsSource === 'symplr'
					? 'Unfortunately, the professions listed in your Profile do not match with the shift’s requirement. If you still want to request, please update the professions listed in your profile to include those in the shift’s requirement'
					: 'Unfortunately, the professions listed in your Profile do not match with job’s required profession. If you still want to apply, please update the professions listed in your profile to include those in the job’s requirement'
			}
			title={
				currentJob?.atsSource === 'symplr'
					? 'Your profile does not match with the shift ’s required profession'
					: 'Your profile does not match with the job’s required profession'
			}
		/>
	)
})
